var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M18.7106 51.0038C11.0213 45.663 7.9009 35.8084 11.1148 27.0151C14.3287 18.2219 23.0684 12.7021 32.3894 13.5785C41.7105 14.455 49.2681 21.5071 50.7865 30.7453C51.2242 30.7142 51.6306 30.6828 52.0683 30.6828C58.9193 30.6804 64.7752 35.6152 65.934 42.3675C67.0929 49.1198 63.2175 55.7246 56.7577 58.0067",
    stroke: "#266EF1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M47.3789 47.8785L38 38.4996L28.6211 47.8785",
    stroke: "#266EF1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M38.0007 38.4996V63.5093",
    stroke: "#266EF1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlue);
export default __webpack_public_path__ + "static/media/upload-blue.39a37c4898cda5b41c08826536e0589d.svg";
export { ForwardRef as ReactComponent };